import {
  CheckoutTabHeaderMolecule,
  RoundedCheckboxMolecule,
} from '../../molecules';
import React from 'react';
import { CustomerAddressLabels } from '../../../enums/pages/checkout/customer-address-labels';
import { usState } from '../../../data/customer/us-state';
import { Region } from '@hiwaldo/sdk';
import { storeRegion } from '../../../utils';
import { euCountry } from '../../../data/customer/eu-country';
import { useCheckoutStyles } from '../../../styles/templates/checkout.styles';
import { PatientStepsHeader } from '../../../data/pages/checkout/patient-steps.data';
import { CheckoutButtons } from '../../../enums/pages/checkout/checkout-buttons';
import { usePatientEffect } from '../../../effects';
import { FormFieldValue } from '../../../forms';

type PatientShippingField =
  | 'shippingFirstName'
  | 'shippingLastName'
  | 'shippingCompany'
  | 'shippingLine1'
  | 'shippingLine2'
  | 'shippingCity'
  | 'shippingState'
  | 'shippingPostalCode'
  | 'shippingCountry'
  | 'shippingPhone';

type PatientBillingField =
  | 'billingFirstName'
  | 'billingLastName'
  | 'billingCompany'
  | 'billingLine1'
  | 'billingLine2'
  | 'billingCity'
  | 'billingState'
  | 'billingPostalCode'
  | 'billingCountry'
  | 'billingPhone';

export const PatientShippingStepOrganism = () => {
  const region = storeRegion();
  const classes = useCheckoutStyles();
  const { patientShippingFormState, onSubmitPatient } =
    usePatientEffect('shipping');

  const toggleAddress = (shipping: boolean) => {
    if (shipping) {
      patientShippingFormState.members.matchAddress.onChange(true);

      patientShippingFormState.members.billingFirstName.onChange(
        patientShippingFormState.members.shippingFirstName.value
      );
      patientShippingFormState.members.billingLastName.onChange(
        patientShippingFormState.members.shippingLastName.value
      );
      patientShippingFormState.members.billingCompany.onChange(
        patientShippingFormState.members.shippingCompany.value
      );
      patientShippingFormState.members.billingLine1.onChange(
        patientShippingFormState.members.shippingLine1.value
      );
      patientShippingFormState.members.billingLine2.onChange(
        patientShippingFormState.members.shippingLine2.value
      );
      patientShippingFormState.members.billingCity.onChange(
        patientShippingFormState.members.shippingCity.value
      );
      patientShippingFormState.members.billingState.onChange(
        patientShippingFormState.members.shippingState.value
      );
      patientShippingFormState.members.billingPostalCode.onChange(
        patientShippingFormState.members.shippingPostalCode.value
      );
      patientShippingFormState.members.billingCountry.onChange(
        patientShippingFormState.members.shippingCountry.value
      );
      patientShippingFormState.members.billingPhone.onChange(
        patientShippingFormState.members.shippingPhone.value
      );
    } else {
      patientShippingFormState.members.matchAddress.onChange(false);

      patientShippingFormState.members.billingFirstName.doReset(true);
      patientShippingFormState.members.billingLastName.doReset(true);
      patientShippingFormState.members.billingCompany.doReset(true);
      patientShippingFormState.members.billingLine1.doReset(true);
      patientShippingFormState.members.billingLine2.doReset(true);
      patientShippingFormState.members.billingCity.doReset(true);
      patientShippingFormState.members.billingState.doReset(true);
      patientShippingFormState.members.billingPostalCode.doReset(true);
      patientShippingFormState.members.billingCountry.doReset(true);
      patientShippingFormState.members.billingPhone.doReset(true);
    }
  };

  const updateShippingField = (
    field: PatientShippingField,
    value: FormFieldValue
  ) => {
    patientShippingFormState.members[field].onChange(value);

    if (patientShippingFormState.members.matchAddress.value) {
      const billingField = field.replace(
        'shipping',
        'billing'
      ) as PatientBillingField;

      patientShippingFormState.members[billingField].onChange(value);
    }
  };

  return (
    <div data-cy="checkout-address-step-organism">
      <div
        className={`bg-white py-5 lg:py-0 border-b border-waldo-blue ${classes.checkout}`}
      >
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.DOCTOR}
          editable={true}
        />

        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.REGISTER}
          editable={true}
        />

        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.PLAN}
          editable={true}
        />

        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.PRESCRIPTION}
          editable={true}
        />

        <div className="py-8 w-11/12 mx-auto lg:mx-0">
          <h1 className="text-tabTitle font-normal font-waldo-regular no-underline">
            {PatientStepsHeader.SHIPPING}
          </h1>
          <div data-cy="checkout-shipping-step-organism">
            <div className="relative">
              <label htmlFor="customer-first-name" className="hidden" />
              <input
                className={`${
                  !patientShippingFormState.members.shippingFirstName.isClean &&
                  !patientShippingFormState.members.shippingFirstName.isValid &&
                  'input-error-border'
                }`}
                type="input"
                id="customer-first-name"
                placeholder={CustomerAddressLabels.FIRSTNAME}
                onChange={(e) =>
                  updateShippingField('shippingFirstName', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingFirstName.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingFirstName.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingFirstName
                    .value as string
                }
              />
              {!patientShippingFormState.members.shippingFirstName.isClean &&
                !patientShippingFormState.members.shippingFirstName.isValid &&
                patientShippingFormState.members.shippingFirstName.errors
                  .length > 0 && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {
                      patientShippingFormState.members.shippingFirstName
                        .errors[0]
                    }
                  </div>
                )}
            </div>
            <div className="relative">
              <label htmlFor="customer-last-name" className="hidden" />
              <input
                className={`${
                  !patientShippingFormState.members.shippingLastName.isClean &&
                  !patientShippingFormState.members.shippingLastName.isValid &&
                  'input-error-border'
                }`}
                type="input"
                id="customer-last-name"
                placeholder={CustomerAddressLabels.LASTNAME}
                onChange={(e) =>
                  updateShippingField('shippingLastName', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingLastName.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingLastName.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingLastName
                    .value as string
                }
              />
              {!patientShippingFormState.members.shippingLastName.isClean &&
                !patientShippingFormState.members.shippingLastName.isValid &&
                patientShippingFormState.members.shippingLastName.errors
                  .length > 0 && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {
                      patientShippingFormState.members.shippingLastName
                        .errors[0]
                    }
                  </div>
                )}
            </div>
            <div className="relative">
              <label htmlFor="customer-address" className="hidden" />
              <input
                className={`${
                  !patientShippingFormState.members.shippingLine1.isClean &&
                  !patientShippingFormState.members.shippingLine1.isValid &&
                  'input-error-border'
                }`}
                type="input"
                id="customer-address"
                placeholder={CustomerAddressLabels.LINE_1}
                onChange={(e) =>
                  updateShippingField('shippingLine1', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingLine1.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingLine1.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingLine1.value as string
                }
              />
              {!patientShippingFormState.members.shippingLine1.isClean &&
                !patientShippingFormState.members.shippingLine1.isValid &&
                patientShippingFormState.members.shippingLine1.errors.length >
                  0 && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {patientShippingFormState.members.shippingLine1.errors[0]}
                  </div>
                )}
            </div>
            <div className="relative">
              <label htmlFor="customer-company" className="hidden" />
              <input
                className=""
                type="input"
                id="customer-company"
                placeholder={CustomerAddressLabels.COMPANY}
                onChange={(e) =>
                  updateShippingField('shippingCompany', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingCompany.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingCompany.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingCompany
                    .value as string
                }
              />
            </div>
            <div className="relative">
              <label htmlFor="customer-address-2" className="hidden" />
              <input
                className=""
                type="input"
                id="customer-address-2"
                placeholder={CustomerAddressLabels.LINE_2}
                onChange={(e) =>
                  updateShippingField('shippingLine2', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingLine2.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingLine2.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingLine2.value as string
                }
              />
            </div>
            <div className="relative">
              <label htmlFor="customer-city" className="hidden" />
              <input
                className={`${
                  !patientShippingFormState.members.shippingCity.isClean &&
                  !patientShippingFormState.members.shippingCity.isValid &&
                  'input-error-border'
                }`}
                type="input"
                id="customer-city"
                placeholder={CustomerAddressLabels.CITY}
                onChange={(e) =>
                  updateShippingField('shippingCity', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingCity.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingCity.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingCity.value as string
                }
              />
              {!patientShippingFormState.members.shippingCity.isClean &&
                !patientShippingFormState.members.shippingCity.isValid &&
                patientShippingFormState.members.shippingCity.errors.length >
                  0 && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {patientShippingFormState.members.shippingCity.errors[0]}
                  </div>
                )}
            </div>
            <div className="relative">
              <label htmlFor="customer-state" className="hidden" />
              {region == Region.US && (
                <select
                  id="customer-state"
                  className="font-normal"
                  onChange={(e) =>
                    updateShippingField('shippingState', e.target.value)
                  }
                  onFocus={() =>
                    patientShippingFormState.members.shippingState.onFocus()
                  }
                  onBlur={() =>
                    patientShippingFormState.members.shippingState.onBlur()
                  }
                  value={
                    patientShippingFormState.members.shippingState
                      .value as string
                  }
                >
                  <option value="">Select {CustomerAddressLabels.STATE}</option>
                  {usState.map((state, index) => (
                    <option
                      key={index}
                      value={state.code}
                      selected={
                        patientShippingFormState.members.shippingState.value ===
                        state.code
                      }
                    >
                      {state.name}
                    </option>
                  ))}
                </select>
              )}
              {region !== Region.US && (
                <input
                  type="input"
                  id="customer-state"
                  placeholder={CustomerAddressLabels.COUNTY}
                  className="my-0.5 placeholder-waldo-blue"
                  onChange={(e) =>
                    updateShippingField('shippingState', e.target.value)
                  }
                  onFocus={() =>
                    patientShippingFormState.members.shippingState.onFocus()
                  }
                  onBlur={() =>
                    patientShippingFormState.members.shippingState.onBlur()
                  }
                  value={
                    patientShippingFormState.members.shippingState
                      .value as string
                  }
                />
              )}
              {!patientShippingFormState.members.shippingState.isClean &&
                !patientShippingFormState.members.shippingState.isValid &&
                patientShippingFormState.members.shippingState.errors.length >
                  0 && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {patientShippingFormState.members.shippingState.errors[0]}
                  </div>
                )}
            </div>
            <div className="relative">
              <label htmlFor="customer-zip" className="hidden" />
              <input
                className={`${
                  !patientShippingFormState.members.shippingPostalCode
                    .isClean &&
                  !patientShippingFormState.members.shippingPostalCode
                    .isValid &&
                  'input-error-border'
                }`}
                type="input"
                id="customer-zip"
                placeholder={CustomerAddressLabels.ZIP}
                onChange={(e) =>
                  updateShippingField('shippingPostalCode', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingPostalCode.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingPostalCode.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingPostalCode
                    .value as string
                }
              />
              {!patientShippingFormState.members.shippingPostalCode.isClean &&
                !patientShippingFormState.members.shippingPostalCode.isValid &&
                patientShippingFormState.members.shippingPostalCode.errors
                  .length > 0 && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {
                      patientShippingFormState.members.shippingPostalCode
                        .errors[0]
                    }
                  </div>
                )}
            </div>
            <div className="relative">
              <label htmlFor="customer-country" className="hidden" />
              <select
                id="customer-country"
                className="font-normal"
                onChange={(e) =>
                  updateShippingField('shippingCountry', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingCountry.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingCountry.onBlur()
                }
              >
                <option value="">Select {CustomerAddressLabels.COUNTRY}</option>
                {region == Region.US && (
                  <option
                    value={Region.US}
                    selected={
                      patientShippingFormState.members.shippingCountry.value ==
                      Region.US
                    }
                  >
                    United States
                  </option>
                )}
                {region == Region.UK && (
                  <option
                    value={Region.UK}
                    selected={
                      patientShippingFormState.members.shippingCountry.value ===
                      Region.UK
                    }
                  >
                    United Kingdom
                  </option>
                )}
                {region == Region.EU && (
                  <>
                    {euCountry.map((country, index) => (
                      <option
                        key={index}
                        value={country.code}
                        selected={
                          patientShippingFormState.members.shippingCountry
                            .value === country.code
                        }
                      >
                        {country.name}
                      </option>
                    ))}
                  </>
                )}
                {region == Region.SE && (
                  <option
                    value={Region.SE}
                    selected={
                      patientShippingFormState.members.shippingCountry.value ===
                      Region.SE
                    }
                  >
                    Sweden
                  </option>
                )}
              </select>
              {!patientShippingFormState.members.shippingCountry.isClean &&
                !patientShippingFormState.members.shippingCountry.isValid && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {patientShippingFormState.members.shippingCountry.errors[0]
                      ? patientShippingFormState.members.shippingCountry
                          .errors[0]
                      : 'required'}
                  </div>
                )}
            </div>
            <div className="relative">
              <label htmlFor="customer-phone" className="hidden" />
              <input
                className={`${
                  !patientShippingFormState.members.shippingPhone.isClean &&
                  !patientShippingFormState.members.shippingPhone.isValid &&
                  'input-error-border'
                }`}
                type="input"
                id="customer-phone"
                placeholder={CustomerAddressLabels.PHONE}
                onChange={(e) =>
                  updateShippingField('shippingPhone', e.target.value)
                }
                onFocus={() =>
                  patientShippingFormState.members.shippingPhone.onFocus()
                }
                onBlur={() =>
                  patientShippingFormState.members.shippingPhone.onBlur()
                }
                value={
                  patientShippingFormState.members.shippingPhone.value as string
                }
              />
              {!patientShippingFormState.members.shippingPhone.isClean &&
                !patientShippingFormState.members.shippingPhone.isValid &&
                patientShippingFormState.members.shippingPhone.errors.length >
                  0 && (
                  <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                    <div className="error-icon"></div>
                    {patientShippingFormState.members.shippingPhone.errors[0]}
                  </div>
                )}
            </div>
          </div>

          <div
            data-cy="checkout-billing-step-organism"
            className="bg-white mt-3"
          >
            <p className="text-base no-underline mb-5 font-semibold">
              {PatientStepsHeader.BILLING}
            </p>
            <div className="mb-5">
              <RoundedCheckboxMolecule
                label="Use Shipping address"
                checked={!!patientShippingFormState.members.matchAddress.value}
                name="matchAddress"
                onClick={() => toggleAddress(true)}
                value={
                  patientShippingFormState.members.matchAddress.value ? 1 : 0
                }
              />
              <RoundedCheckboxMolecule
                label="Use a different billing address"
                checked={!patientShippingFormState.members.matchAddress.value}
                name="matchAddress"
                onClick={() => toggleAddress(false)}
                value={
                  !patientShippingFormState.members.matchAddress.value ? 1 : 0
                }
              />
            </div>
            {!patientShippingFormState.members.matchAddress.value && (
              <div>
                <div className="relative">
                  <label htmlFor="customer-first-name" className="hidden" />
                  <input
                    className={`${
                      !patientShippingFormState.members.billingFirstName
                        .isClean &&
                      !patientShippingFormState.members.billingFirstName
                        .isValid &&
                      'input-error-border'
                    }`}
                    type="input"
                    id="customer-first-name"
                    placeholder={CustomerAddressLabels.FIRSTNAME}
                    onChange={(e) =>
                      patientShippingFormState.members.billingFirstName.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingFirstName.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingFirstName.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingFirstName
                        .value as string
                    }
                  />
                  {!patientShippingFormState.members.billingFirstName.isClean &&
                    !patientShippingFormState.members.billingFirstName
                      .isValid &&
                    patientShippingFormState.members.billingFirstName.errors
                      .length > 0 && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {
                          patientShippingFormState.members.billingFirstName
                            .errors[0]
                        }
                      </div>
                    )}
                </div>
                <div className="relative">
                  <label htmlFor="customer-last-name" className="hidden" />
                  <input
                    className={`${
                      !patientShippingFormState.members.billingLastName
                        .isClean &&
                      !patientShippingFormState.members.billingLastName
                        .isValid &&
                      'input-error-border'
                    }`}
                    type="input"
                    id="customer-last-name"
                    placeholder={CustomerAddressLabels.LASTNAME}
                    onChange={(e) =>
                      patientShippingFormState.members.billingLastName.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingLastName.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingLastName.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingLastName
                        .value as string
                    }
                  />
                  {!patientShippingFormState.members.billingLastName.isClean &&
                    !patientShippingFormState.members.billingLastName.isValid &&
                    patientShippingFormState.members.billingLastName.errors
                      .length > 0 && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {
                          patientShippingFormState.members.billingLastName
                            .errors[0]
                        }
                      </div>
                    )}
                </div>
                <div className="relative">
                  <label htmlFor="customer-address" className="hidden" />
                  <input
                    className={`${
                      !patientShippingFormState.members.billingLine1.isClean &&
                      !patientShippingFormState.members.billingLine1.isValid &&
                      'input-error-border'
                    }`}
                    type="input"
                    id="customer-address"
                    placeholder={CustomerAddressLabels.LINE_1}
                    onChange={(e) =>
                      patientShippingFormState.members.billingLine1.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingLine1.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingLine1.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingLine1
                        .value as string
                    }
                  />
                  {!patientShippingFormState.members.billingLine1.isClean &&
                    !patientShippingFormState.members.billingLine1.isValid &&
                    patientShippingFormState.members.billingLine1.errors
                      .length > 0 && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {
                          patientShippingFormState.members.billingLine1
                            .errors[0]
                        }
                      </div>
                    )}
                </div>
                <div className="relative">
                  <label htmlFor="customer-company" className="hidden" />
                  <input
                    className=""
                    type="input"
                    id="customer-company"
                    placeholder={CustomerAddressLabels.COMPANY}
                    onChange={(e) =>
                      patientShippingFormState.members.billingCompany.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingCompany.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingCompany.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingCompany
                        .value as string
                    }
                  />
                </div>
                <div className="relative">
                  <label htmlFor="customer-address-2" className="hidden" />
                  <input
                    className=""
                    type="input"
                    id="customer-address-2"
                    placeholder={CustomerAddressLabels.LINE_2}
                    onChange={(e) =>
                      patientShippingFormState.members.billingLine2.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingLine2.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingLine2.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingLine2
                        .value as string
                    }
                  />
                </div>
                <div className="relative">
                  <label htmlFor="customer-city" className="hidden" />
                  <input
                    className={`${
                      !patientShippingFormState.members.billingCity.isClean &&
                      !patientShippingFormState.members.billingCity.isValid &&
                      'input-error-border'
                    }`}
                    type="input"
                    id="customer-city"
                    placeholder={CustomerAddressLabels.CITY}
                    onChange={(e) =>
                      patientShippingFormState.members.billingCity.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingCity.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingCity.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingCity
                        .value as string
                    }
                  />
                  {!patientShippingFormState.members.billingCity.isClean &&
                    !patientShippingFormState.members.billingCity.isValid &&
                    patientShippingFormState.members.billingCity.errors.length >
                      0 && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {patientShippingFormState.members.billingCity.errors[0]}
                      </div>
                    )}
                </div>
                <div className="relative">
                  <label htmlFor="customer-state" className="hidden" />
                  {region == Region.US && (
                    <select
                      id="customer-state"
                      className="font-normal"
                      onChange={(e) =>
                        patientShippingFormState.members.billingState.onChange(
                          e.target.value
                        )
                      }
                      onFocus={() =>
                        patientShippingFormState.members.billingState.onFocus()
                      }
                      onBlur={() =>
                        patientShippingFormState.members.billingState.onBlur()
                      }
                      value={
                        patientShippingFormState.members.billingState
                          .value as string
                      }
                    >
                      <option value="">
                        Select {CustomerAddressLabels.STATE}
                      </option>
                      {usState.map((state, index) => (
                        <option
                          key={index}
                          value={state.code}
                          selected={
                            patientShippingFormState.members.billingState
                              .value === state.code
                          }
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  )}
                  {region !== Region.US && (
                    <input
                      type="input"
                      id="customer-state"
                      placeholder={CustomerAddressLabels.COUNTY}
                      className="my-0.5 placeholder-waldo-blue"
                      onChange={(e) =>
                        patientShippingFormState.members.billingState.onChange(
                          e.target.value
                        )
                      }
                      onFocus={() =>
                        patientShippingFormState.members.billingState.onFocus()
                      }
                      onBlur={() =>
                        patientShippingFormState.members.billingState.onBlur()
                      }
                      value={
                        patientShippingFormState.members.billingState
                          .value as string
                      }
                    />
                  )}
                  {!patientShippingFormState.members.billingState.isClean &&
                    !patientShippingFormState.members.billingState.isValid &&
                    patientShippingFormState.members.billingState.errors
                      .length > 0 && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {
                          patientShippingFormState.members.billingState
                            .errors[0]
                        }
                      </div>
                    )}
                </div>
                <div className="relative">
                  <label htmlFor="customer-zip" className="hidden" />
                  <input
                    className={`${
                      !patientShippingFormState.members.billingPostalCode
                        .isClean &&
                      !patientShippingFormState.members.billingPostalCode
                        .isValid &&
                      'input-error-border'
                    }`}
                    type="input"
                    id="customer-zip"
                    placeholder={CustomerAddressLabels.ZIP}
                    onChange={(e) =>
                      patientShippingFormState.members.billingPostalCode.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingPostalCode.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingPostalCode.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingPostalCode
                        .value as string
                    }
                  />
                  {!patientShippingFormState.members.billingPostalCode
                    .isClean &&
                    !patientShippingFormState.members.billingPostalCode
                      .isValid &&
                    patientShippingFormState.members.billingPostalCode.errors
                      .length > 0 && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {
                          patientShippingFormState.members.billingPostalCode
                            .errors[0]
                        }
                      </div>
                    )}
                </div>
                <div className="relative">
                  <label htmlFor="customer-country" className="hidden" />
                  <select
                    id="customer-country"
                    className="font-normal"
                    onChange={(e) =>
                      patientShippingFormState.members.billingCountry.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingCountry.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingCountry.onBlur()
                    }
                  >
                    <option value="">
                      Select {CustomerAddressLabels.COUNTRY}
                    </option>
                    {region == Region.US && (
                      <option
                        value={Region.US}
                        selected={
                          patientShippingFormState.members.billingCountry
                            .value == Region.US
                        }
                      >
                        United States
                      </option>
                    )}
                    {region == Region.UK && (
                      <option
                        value={Region.UK}
                        selected={
                          patientShippingFormState.members.billingCountry
                            .value === Region.UK
                        }
                      >
                        United Kingdom
                      </option>
                    )}
                    {region == Region.EU && (
                      <>
                        {euCountry.map((country, index) => (
                          <option
                            key={index}
                            value={country.code}
                            selected={
                              patientShippingFormState.members.billingCountry
                                .value === country.code
                            }
                          >
                            {country.name}
                          </option>
                        ))}
                      </>
                    )}
                    {region == Region.SE && (
                      <option
                        value={Region.SE}
                        selected={
                          patientShippingFormState.members.billingCountry
                            .value === Region.SE
                        }
                      >
                        Sweden
                      </option>
                    )}
                  </select>
                  {!patientShippingFormState.members.billingCountry.isClean &&
                    !patientShippingFormState.members.billingCountry
                      .isValid && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {patientShippingFormState.members.billingCountry
                          .errors[0]
                          ? patientShippingFormState.members.billingCountry
                              .errors[0]
                          : 'required'}
                      </div>
                    )}
                </div>
                <div className="relative">
                  <label htmlFor="customer-phone" className="hidden" />
                  <input
                    className={`${
                      !patientShippingFormState.members.billingPhone.isClean &&
                      !patientShippingFormState.members.billingPhone.isValid &&
                      'input-error-border'
                    }`}
                    type="input"
                    id="customer-phone"
                    placeholder={CustomerAddressLabels.PHONE}
                    onChange={(e) =>
                      patientShippingFormState.members.billingPhone.onChange(
                        e.target.value
                      )
                    }
                    onFocus={() =>
                      patientShippingFormState.members.billingPhone.onFocus()
                    }
                    onBlur={() =>
                      patientShippingFormState.members.billingPhone.onBlur()
                    }
                    value={
                      patientShippingFormState.members.billingPhone
                        .value as string
                    }
                  />
                  {!patientShippingFormState.members.billingPhone.isClean &&
                    !patientShippingFormState.members.billingPhone.isValid &&
                    patientShippingFormState.members.billingPhone.errors
                      .length > 0 && (
                      <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                        <div className="error-icon"></div>
                        {
                          patientShippingFormState.members.billingPhone
                            .errors[0]
                        }
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col items-center w-full py-5 lg:py-1">
            <button
              disabled={
                !patientShippingFormState.isValidShipping ||
                !patientShippingFormState.isValidBilling
              }
              className="button btn-third-cta w-80 md:w-[203px] mt-3 text-uppercase font-waldo-header font-medium text-base"
              type="submit"
              onClick={() => onSubmitPatient()}
            >
              <>{CheckoutButtons.NEXT_STEP}</>
            </button>
          </div>
        </div>
      </div>

      <div className="w-11/12 lg:w-full mx-auto">
        <CheckoutTabHeaderMolecule title={PatientStepsHeader.REVIEW} />
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.PAYMENT}
          displayBorder={false}
        />
      </div>
    </div>
  );
};
